import { render } from "./ValuePlayer.vue?vue&type=template&id=ed9d7f18"
import script from "./ValuePlayer.vue?vue&type=script&lang=js"
export * from "./ValuePlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__